<template>
  <div class="main">
    <div class="layout mw9 helvetica">
      <indeterminate-line :active="loading" class="fixed left-0 right-0 top-0"/>

      <div class="left">
        <div class="left-content">
          <component :is="brand" background='black' class="brand" />
          <h2 class="lh-copy f4 fw5 ma0 pa0 white" id="app_description">{{ description }}</h2>

          <div class="flex flex-column justify-start mt4 resources">
            <a v-for="(resource, index) in resources" :key="index"
              :href="resource.url"
              target="_blank"
              class="ma0 pa0 link mb3 white underline f5 db"
            >
            {{ resource.title }}
            </a>
          </div>

        </div>
      </div>

      <div class="right">
        <div class="right-content">
          <h2 class="lh-copy text-primary f3 fw5 ttu ma0 pa0 text-primary align-self-end">Вход</h2>
          <slot />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import ContractBrand from '@/components/brand/Contract.vue'
import AssistantBrand from '@/components/brand/Assistant.vue'
import IndeterminateLine from '@/components/ui/progress/IndeterminateLine.vue'
import { isDocApplication } from '@/utils/app.js'
import { mapGetters } from 'vuex'

export default {
  components: {
    ContractBrand,
    AssistantBrand,
    IndeterminateLine
  },
  props: ['loading'],
  computed: {
    ...mapGetters('about', ['company', 'app', 'description', 'resources']),
    brand () {
      return isDocApplication() ? 'ContractBrand' : 'AssistantBrand'
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
@mixin rows {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto;
  gap: 1rem;
  align-items: start;
}
.resources {
  display: none;
}
.brand {
  width: auto;
}
.main {
  width: 100vw;
  height: 100vh;
  z-index: 1;
  &:before {
    z-index: -1;
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #334E68;
    clip-path: polygon(0 0, 100% 0, 100% 200px, 0% 100%);
  }
}
.layout {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: 200px auto;
  grid-template-areas:
    "left"
    "right";
  width: 100%;
  height: 100%;
}
.left {
  grid-area: left;
  @include center;
  padding: 2rem;
  // background-color: #334E68;
  &-content {
    @include rows;
  }
}
.right {
  grid-area: right;
  @include center;
  &-content {
    @include rows;
    margin: 1rem;
    padding: 2rem;
    width: 90%;
    background-color: white;
    box-shadow: 0 0 20px rgba(30, 46, 62, .5), 0 0 10px rgba(30, 46, 62, .2);
  }
}
@media screen and (min-width: 60em) {
  .resources {
    display: block;
  }
  .brand {
    height: 40px;
    width: auto;
  }
  .main {
    position: relative;
    height: 100vh;
    width: 100vw;
    z-index: 1;
    &:before {
      z-index: -1;
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: #334E68;
      clip-path: polygon(0 0, 53% 0, 47% 100%, 0% 100%);
      // clip-path: polygon(0 0, 70% 0, 60% 100%, 0% 100%);
    }
    @include center;
  }
  .layout {
    width: 90%;
    height: 70%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    grid-template-areas: "left right";
    background-color: transparent;
    box-shadow: 0 0 20px rgba(30, 46, 62, .5), 0 0 10px rgba(30, 46, 62, .2);
  }
  .left {
    @include center;
    grid-area: left;
    &-content {
      @include rows;
      max-width: 20rem;
    }
  }
  .right {
    grid-area: right;
    @include center;
    &-content {
      @include rows;
      background-color: transparent;
      min-width: 25rem;
      max-width: 30rem;
      box-shadow: none;
      padding: 4.5rem;
    }
  }
}
</style>
